/* eslint-disable import/no-cycle */
import { store } from '../../../store';
import { validateEmail } from '../../../utils/validator';
import { addErrorsItem, addWarnings } from '../actions';
import {
  isEuCountry,
  isArmyPost,
  requiredCompanyName,
  requiredPickupPointId,
  isDromPostCode
} from '../utils/checker';

/**
 * Récupération de valeur dans le store redux
 * @param  {Object} state Représente les données du store global rédux
 */
function select(state) {
  return {
    productIsInStock: state.importCommands.productIsInStock,
    existingReferences: state.importCommands.existingReferences,
    productBarcode: state.init.productBarcode,
    isStockHandled: state.init.isStockHandled
  };
}

function storeListner() {
  return select(store.getState());
}

store.subscribe(storeListner);

/**
 * Validation de tout les formulaires présent
 * dans l'import de commande
 *
 * @param  {Object} values       valeur présente dans les formulaires
 * @param  {Number} commandIndex Index de la commande à valider
 * @return {Object}              Object contenant toute les erreurs pour la commande
 */
const validate = (values, { commandIndex }) => {
  const fullErrors = [];
  const fullwarnings = [];
  const errors = {};
  const recipientErrors = {};
  const recipientAddressErrors = {};
  const pickupPointErrors = {};

  const customDeclarationArrayErrors = [];
  const itemsArrayErrors = [];
  if (!values.externalReference) {
    errors.externalReference = 'Champs requis';
    fullErrors.push('Veuillez ajouter la référence de la commande');
  }

  if (requiredPickupPointId(values.offerCode)) {
    /* if (!values.pickupPoint.id) {
      pickupPointErrors.id = 'Champs requis';
      fullErrors.push('Veuillez ajouter un point relais à la commande');
    } */
  }

  if (values.externalReference) {
    if (
      storeListner().existingReferences.find(
        existingReference =>
          existingReference.toLowerCase() ===
          values.externalReference.toString().toLowerCase()
      )
    ) {
      fullwarnings.push(
        `Une commande avec la référence ${
          values.externalReference
        } a déjà été importée`
      );
      // errors.externalReference = 'Existe déjà';
      // TODO: Ajouter la notion de warning
    }
  }

  if (values.recipient) {
    if (!values.recipient.email) {
      recipientErrors.email = 'Champs requis';
      fullErrors.push('Veuillez ajouter un email');
    }

    if (values.recipient.email && !validateEmail(values.recipient.email)) {
      recipientErrors.email = 'Adresse email invalide';
      fullErrors.push('Veuillez utiliser une adresse email valide');
    }

    if (!values.recipient.lastname) {
      recipientErrors.lastname = 'Champs requis';
      fullErrors.push('Veuillez ajouter un nom');
    }

    if (!values.recipient.firstname) {
      recipientErrors.firstname = 'Champs requis';
      fullErrors.push('Veuillez ajouter un prénom');
    }

    if (!values.recipient.phoneNumber) {
      recipientErrors.phoneNumber = 'Champs requis';
      fullErrors.push('Veuillez ajouter un numéro de téléphone');
    }
    if (requiredCompanyName(values.offerCode)) {
      if (!values.recipient.companyName) {
        recipientErrors.companyName = 'Champs requis';
        fullErrors.push("Veuillez ajouter un nom d'entreprise");
      }
    }
  }
  if (values.recipientAddress) {
    if (!values.recipientAddress.countryCode) {
      recipientAddressErrors.countryCode = 'Champs requis';
      fullErrors.push('Veuillez ajouter le pays');
    }

    if (values.recipientAddress.countryCode) {
      if (
        values.recipientAddress.countryCode === 'FR' &&
        isDromPostCode(values.recipientAddress.postalCode)
      ) {
        recipientAddressErrors.countryCode =
          'Pays incorrect par rapport au code postal';
        fullErrors.push(
          'Le pays France correspond uniquement à la France métropolitaine pour un envoi en DROM veuillez modifier le pays'
        );
      }
    }

    if (!values.recipientAddress.street) {
      recipientAddressErrors.street = 'Champs requis';
      fullErrors.push('Veuillez ajouter une adresse');
    }

    if (!values.recipientAddress.postalCode) {
      recipientAddressErrors.postalCode = 'Champs requis';
      fullErrors.push('Veuillez ajouter un code postal');
    } else if (values.recipientAddress.postalCode.length > 10) {
      recipientAddressErrors.postalCode = 'Champs trop long (Max. 10)';
      fullErrors.push('Veuillez ajouter un code postal valide');
    }

    if (!values.recipientAddress.city) {
      recipientAddressErrors.city = 'Champs requis';
      fullErrors.push('Veuillez ajouter une ville');
    }
  }

  if (Object.keys(recipientErrors).length !== 0) {
    errors.recipient = recipientErrors;
  }

  if (Object.keys(recipientAddressErrors).length !== 0) {
    errors.recipientAddress = recipientAddressErrors;
  }

  if (Object.keys(pickupPointErrors).length !== 0) {
    errors.pickupPoint = pickupPointErrors;
  }

  if (
    values.customsDeclarations &&
    (!isEuCountry(values.recipientAddress.countryCode) ||
      isArmyPost(values.recipientAddress.postalCode))
  ) {
    values.customsDeclarations.forEach(
      (customDeclaration, customDeclarationIndex) => {
        const customDeclarationErrors = {};

        if (!customDeclaration || !customDeclaration.currency) {
          customDeclarationErrors.currency = 'Champs requis';
          fullErrors.push(
            `Veuillez ajouter une devise pour le produit n° ${customDeclarationIndex +
              1} de votre commande`
          );
          customDeclarationArrayErrors[
            customDeclarationIndex
          ] = customDeclarationErrors;
        }

        if (!customDeclaration || !customDeclaration.declaredValue) {
          customDeclarationErrors.declaredValue = 'Champs requis';
          fullErrors.push(
            `Veuillez ajouter la valeur du produit n° ${customDeclarationIndex +
              1} de votre commande`
          );
          customDeclarationArrayErrors[
            customDeclarationIndex
          ] = customDeclarationErrors;
        }

        if (customDeclaration.declaredValue) {
          if (Number.isNaN(+customDeclaration.declaredValue)) {
            customDeclarationErrors.declaredValue =
              'Valeur incorrect ( exemple de valeur correcte : 42.99 )';
            fullErrors.push(
              `Veuillez modifier la valeur du produit n° ${customDeclarationIndex +
                1} de votre commande`
            );
            customDeclarationArrayErrors[
              customDeclarationIndex
            ] = customDeclarationErrors;
          }
        }

        if (!customDeclaration || !customDeclaration.objectType) {
          customDeclarationErrors.objectType = 'Champs requis';
          fullErrors.push(
            `Veuillez ajouter une description douanière pour le produit n° ${customDeclarationIndex +
              1} de votre commande`
          );
          customDeclarationArrayErrors[
            customDeclarationIndex
          ] = customDeclarationErrors;
        }

        if (!customDeclaration || !customDeclaration.quantity) {
          customDeclarationErrors.quantity = 'Champs requis';
          fullErrors.push(
            `Veuillez ajouter une quantité pour le produit n° ${customDeclarationIndex +
              1} de votre commande`
          );
          customDeclarationArrayErrors[
            customDeclarationIndex
          ] = customDeclarationErrors;
        }
      }
    );
  }

  if (values.items) {
    values.items.forEach((item, itemIndex) => {
      const itemErrors = {};
      if (!item || !item.externalReference) {
        itemErrors.externalReference = 'Champs requis';
        fullErrors.push(
          `Veuillez ajouter une référence pour le produit n° ${itemIndex +
            1} de votre commande`
        );
      }

      if (
        (!item || !item.ean13) &&
        storeListner().isStockHandled &&
        storeListner().productIsInStock === true
      ) {
        itemErrors.ean13 = 'Champs requis';
        fullErrors.push(
          `Veuillez ajouter un ean 13 pour le produit n° ${itemIndex +
            1} de votre commande`
        );
      }
      if (
        item.ean13 &&
        storeListner().isStockHandled &&
        storeListner().productIsInStock === true
      ) {
        if (
          !storeListner().productBarcode.filter(
            barcode => barcode.barcodeValue.toString() === item.ean13.toString()
          ).length > 0
        ) {
          fullErrors.push(
            `Veuillez modifier le code-barres (EAN13) pour le produit n° ${itemIndex +
              1}`
          );
          itemErrors.ean13 = 'Code-barres inconnu';
        }
      }

      if (!item || !item.quantity) {
        itemErrors.quantity = 'Champs requis';
        fullErrors.push(
          `Veuillez ajouter une quantité pour le produit n° ${itemIndex +
            1} de votre commande`
        );
      }
      // if (!item || !item.description) {
      //   itemErrors.description = 'Champs requis'
      //   fullErrors.push(`Veuillez ajouter une description pour le produit n° ${itemIndex + 1} de votre commande`)
      //   itemsArrayErrors[itemIndex] = itemErrors
      // }
      itemsArrayErrors[itemIndex] = itemErrors;
    });
  }

  if (customDeclarationArrayErrors.length) {
    errors.customsDeclarations = customDeclarationArrayErrors;
  }

  if (itemsArrayErrors.length) {
    errors.items = itemsArrayErrors;
  }
  store.dispatch(addErrorsItem({ fullErrors, commandIndex }));
  store.dispatch(addWarnings({ fullwarnings, commandIndex }));
  return errors;
};

export default validate;
